import { useCallback, useEffect, useState } from 'react';
import { getConvertedValue_ } from '../helpers';

export const useConverting = ({
    userToken,
    lang,
    localization,
    cartData,
    selectedPaymentSystems,
    isComboPayment,
    setConvertedData
}) => {
    const [convertLoading, setConvertLoading] = useState([]);
    const [debouncedSelectedPaymentSystems, setDebouncedSelectedPaymentSystems] = useState([]);

    useEffect(() => {
        if (selectedPaymentSystems?.length) {
            const paymentSystemsWithSumValue = [];
            selectedPaymentSystems?.forEach((item) => {
                if (item?.sumValue) {
                    paymentSystemsWithSumValue.push(item?.id);
                }
            });
            setConvertLoading(paymentSystemsWithSumValue);
            const timerId = setTimeout(() => {
                setDebouncedSelectedPaymentSystems(selectedPaymentSystems);
            }, 1000);
            return () => {
                clearTimeout(timerId);
            };
        }
    }, [selectedPaymentSystems, isComboPayment]);

    const getConvertedValue = useCallback(
        async (from_finance_currency, to_finance_currency, amount, id) => {
            if (from_finance_currency === to_finance_currency) {
                return { amount, id };
            }
            const result = await getConvertedValue_(from_finance_currency, to_finance_currency, amount, lang, userToken);
            return { ...result?.data, id };
        },
        [lang, userToken]
    );

    const getConvertedData = useCallback(
        async (debouncedSelectedPaymentSystems_) => {
            const promises = debouncedSelectedPaymentSystems_.map((item) => {
                if (item?.sumValue) {
                    return getConvertedValue(
                        localization?.currency,
                        item?.currency?.code || cartData?.main_currency?.code,
                        item?.sumValue,
                        item.id
                    );
                }
                return;
            });
            const results = await Promise.all(promises);
            setConvertLoading([]);
            setConvertedData(results);
        },
        [cartData?.main_currency?.code, getConvertedValue, localization?.currency, setConvertedData]
    );

    useEffect(() => {
        if (debouncedSelectedPaymentSystems?.length) {
            getConvertedData(debouncedSelectedPaymentSystems);
        }
    }, [debouncedSelectedPaymentSystems, getConvertedData]);
    return { convertLoading, debouncedSelectedPaymentSystems, setDebouncedSelectedPaymentSystems, setConvertLoading };
};
